import COUNTRY_TYPES from 'constants/countryTypes'
import { isEmpty } from 'helpers/utils'
import { LANGUAGE_TAGS } from 'localization/constants/languages'
import { parseCountry, parseItalyOrSpain } from 'localization/helpers'

export const getCountryType = (countries, language) => {
  let country = ''
  if (
    language.toLocaleLowerCase() === LANGUAGE_TAGS.ESPAÑA.toLocaleLowerCase() ||
    language.toLocaleLowerCase() === LANGUAGE_TAGS.ITALY.toLocaleLowerCase()
  ) {
    country = countries.find(({ code }) => code.toLocaleLowerCase() === parseItalyOrSpain(language))
  } else {
    country = countries.find(({ code }) => code === parseCountry(language))
  }
  return country || COUNTRY_TYPES
}

export const getCountryCode = (countries, language) => {
  return getCountryType(countries, language).code
}

export const getCountryAreaCode = (countries, language) => {
  return getCountryType(countries, language).areaCode
}

export const getCountry = (countries, language) => {
  const country = countries.find(({ code }) => code === parseCountry(language))
  return isEmpty(countries)
    ? { value: 'AR', label: 'Argentina' }
    : { value: country.code, label: country.name }
}
